import {SubSectionCardHeader} from "base/ui/section/components";
import {TreeChip, TreeDataFields} from ".";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";

const TreeCard = ({tree, displayFees = true}) => {
    return (
        <Card sx={{border: 1, borderRadius: 2, borderColor: "grey.300"}} elevation={0}>
            <SubSectionCardHeader titleTags={<TreeChip element={tree} />} />
            <CardContent>
                <TreeDataFields tree={tree} displayFees={displayFees} />
            </CardContent>
        </Card>
    );
};

export default TreeCard;
